import * as React from 'react';

import { Avatar, ContentSection } from '@rematter/ui-web';

import { SupplierAccountRecord } from '../../_graphql/querySupplierAccountsByIds';
import { useTranslations } from '../../i18n/useTranslations';
import { LabeledText } from '../salesOrders/LabeledText';

type Props = {
  selectedAccount: SupplierAccountRecord;
};

export const PurchaseOrderTabSupplierSectionContacts: React.FC<Props> = ({
  selectedAccount,
}) => {
  const t = useTranslations();
  const contacts = selectedAccount?.contacts ?? [];

  return (
    <ContentSection
      variant="panel"
      className="@PurchaseOrderTabSupplierSectionContacts"
      title={t.purchaseOrderDetail.supplier.sections.contacts}
    >
      {contacts.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8">
          <p className="text-sm text-neutral/50">
            {t.purchaseOrderDetail.supplier.noContacts}
          </p>
        </div>
      ) : (
        contacts.map((contact) => (
          <div
            className="mt-4 flex flex-row items-center gap-4"
            key={contact.id}
          >
            <div className="flex w-[356px] flex-row items-center gap-[10px]">
              <Avatar name={contact.fullName} size="xl" />
              <div className="flex flex-col">
                <LabeledText label="Contact" text={contact.fullName} />
                {contact.isPrimary && (
                  <span className="text-xs font-medium text-primary-darker">
                    {t.purchaseOrderDetail.supplier.primaryContact}
                  </span>
                )}
              </div>
            </div>
            <span className="w-[356px] text-primary">
              {contact.phone || '-'}
            </span>
            <span className="w-[356px] text-primary">
              {contact.email || '-'}
            </span>
          </div>
        ))
      )}
    </ContentSection>
  );
};
